module.exports = __webpack_public_path__ + "img/bargain_tit2.65367167.png";